import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker, DateTimePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isCommitDialogOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { isEndCommitmentDialogOpen } from '../../selectors/phaseplan.selector';
import { dialogActions } from '../../actions/dialog.actions';

interface Props {
    isEndCommitmentDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    endActiveCommitment: () => void
}


class EndCommitmentDialog extends Component<Props, {}> {

    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
        const { closeDialogValue, endActiveCommitment } = this.props
        batch(() => {
            endActiveCommitment()
            closeDialogValue()
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                maxWidth='sm'
                fullWidth={true}
                open={!!this.props.isEndCommitmentDialogOpen}
                onBackdropClick={this.closeDialog.bind(this)}
            >
                <DialogContent>
                    <div style={{ backgroundColor: '' }} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            End Commitment
                        </p>
                    </div>
                    <div className={classes.DialogFormContent} >
                        <Typography variant="subtitle1">
                            Choose committ tags to a commitment log.
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm} color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state: any) => ({
    isEndCommitmentDialogOpen: isEndCommitmentDialogOpen(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closeEndCommitmentDialog()),
        endActiveCommitment: () => dispatch(lookaheadActions.endActiveCommitment())
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(EndCommitmentDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/EndCommitmentDialog.tsx